<template>
    <div>
        <h1 class="title">Willkommen</h1>

        <p>Hallo, mein Name ist Eva Doleisch von Dolsperg. Ich bin Steuerberaterin in Hannover.</p>
        <br/>
        <p>Seit über 30 Jahren bin ich sehr erfolgreich auf dem Gebiet des Steuerrechts tätig, teils als Leiterin einer
            Steuer- und Rechtsanwaltskanzlei, aber auch wie heute ausschließlich im eigenen Büro und auf eigene
            Rechnung.</p>
        <br/>
        <p>Mein Grundwissen habe ich an der <a href="http://www.akademie-henssler.de/">Akademie Henssler</a>, einer
            profilierten Leistungsakademie in Rotensol bei Bad Herrenalb, erhalten, deren Seminare und Vorträge ich noch
            heute laufend besuche.</p>
        <br/>
        <p>Ich kann daher auf fundiertes Steuerrecht und Praxiswissen zurück greifen. Wenn Sie, liebe Besucher meiner
            Homepage, einen steuerlichen Rat oder eine Rundumbetreuung benötigen, freue ich mich über Ihren Anruf oder
            Ihre Nachricht.</p><br/>
        Herzlichst,
        <br/>Ihre Eva Doleisch von Dolsperg.

    </div>
</template>

<script>
    export default {
        data() {
            return {}
        }
    }
</script>